/**
 * Various tools for the OSM wiki
 */
export default class OsmWiki {
    /**
     * Create a link to the wiki for the given key and value (optional)
     * @param key
     * @param value
     */
    public static constructLink(key: string, value?: string): string {
        if (value !== undefined) {
            return `https://wiki.openstreetmap.org/wiki/Tag:${key}%3D${value}`
        }
        return "https://wiki.openstreetmap.org/wiki/Key:" + key
    }

    public static constructLinkMd(key: string, value?: string): string {
        const link = this.constructLink(key, value)
        let displayed = key
        if (value) {
            displayed += "=" + value
        }
        return `[${displayed}](${link})`
    }
}
